module.exports = __webpack_public_path__ + "static/img/6.29c2b38.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/eng/6.png
// module id = owJp
// module chunks = 0